import { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { AuthQuestion } from '@/shared/types/node';

type AuthStepQuestionPreviewProps = { index: number; question: AuthQuestion };

const AuthStepQuestionPreview = memo(({ index, question }: AuthStepQuestionPreviewProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center justify-between py-1 text-xs text-foreground-muted"
      data-testid={`auth-question-preview-${index}`}
    >
      <span className="max-w-[280px] overflow-hidden text-ellipsis whitespace-nowrap">
        {t('dialog.auth.question_label', { 0: index + 1 })} {question.question}
      </span>
      <span className="ml-2 shrink-0 text-[11px] whitespace-nowrap text-foreground-muted">
        {t('dialog.auth.points', { count: question.points })}
      </span>
    </div>
  );
});

AuthStepQuestionPreview.displayName = 'AuthStepQuestionPreview';

export default AuthStepQuestionPreview;
